<section aria-label="Add New Module">
  @if (!module) {
    <h2>Add New Module Group</h2>
  }
  @if (module) {
    <h2>Add New Module</h2>
  }
  <form #form="ngForm">
    <div class="grid-x">
      <div class="auto cell">
        <label>
          <span class="label-text required">Title:</span>
          <input id="title" name="title" type="text" [(ngModel)]="moduleTitle" #title="ngModel" required>
        </label>
        @if (title.errors && (title.dirty || title.touched)) {
          <div class="error-container">
            @if (title.errors.required) {
              <small class="error">Title is required</small>
            }
          </div>
        }
      </div>
    </div>
    <hr />
    <div class="form-button-group">
      <button class="button hollow margin-right" (click)="cancelForm()">Cancel</button>
      <button class="button" (click)="saveForm()" [disabled]="title.invalid">Save</button>
    </div>
  </form>
</section>
